/* 🤖 this file was generated by svg-to-ts */
export const siriusTreeEvergreenDuotone: {
  name: 'tree_evergreen_duotone';
  data: string;
} = {
  name: 'tree_evergreen_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="m12 1.5-7.5 9.75h3.75L3 18h18l-5.25-6.75h3.75L12 1.5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.595 1.043a.75.75 0 0 0-1.19 0l-7.5 9.75A.75.75 0 0 0 4.5 12h2.217l-4.309 5.54A.75.75 0 0 0 3 18.75h8.25v3.75a.75.75 0 0 0 1.5 0v-3.75H21a.75.75 0 0 0 .592-1.21L17.284 12H19.5a.75.75 0 0 0 .595-1.207l-7.5-9.75Zm6.871 16.207-4.308-5.54a.75.75 0 0 1 .592-1.21h2.227L12 2.73 6.023 10.5H8.25a.75.75 0 0 1 .592 1.21l-4.309 5.54h14.933Z" fill="currentColor"/></svg>`
};
